export default function getTableFields(ctx) {
	return [
		{
			field: "order_id",
			// title: this.$t('stats.date'),
			title: "Номер заказа",
			align: "center"
		},
		{
			field: "income",
			title: ctx.$t("stats.income") + ", €",
			align: "center"
		},
		{
			field: "manager",
			title: ctx.$t("stats.manager"),
			align: "center"
		},
		{
			field: "website",
			title: "Сайт",
			align: "center"
		},
		{
			field: "date",
			title: "Дата",
			align: "center"
		}
	];
}
